import { useEffect, useRef } from 'react';

import { Flex, Box, useBreakpointValue, rem } from '@vimeo/bokeh';
import { AiSparkles } from '@vimeo/bokeh-icons';
import { VideoQuestion } from '@vimeo/gctl-api/models/components/schemas/video-question/VideoQuestion';

import { useGetSvvManageBpEvents } from '../../../bp-events';
import * as finalCopy from '../../../copy/final';
import { Choice } from '../../Choice';
import { MultilingualSelector } from '../../MultilingualSelector/MultilingualSelector';

interface QuestionsPanelProps {
  questions: Array<VideoQuestion>;
  onAskPredefinedQuestion: (question: VideoQuestion) => void;
  uniqueLanguages: Array<{ value: string; label: string }>;
  selectedLanguage: string;
  onSelectLanguage: (language: string) => void;
  isEmbeded: boolean;
}

export const QuestionsPanel = ({
  onSelectLanguage,
  selectedLanguage,
  uniqueLanguages,
  questions,
  onAskPredefinedQuestion,
  isEmbeded,
}: QuestionsPanelProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const titleBoxRef = useRef<HTMLDivElement | null>(null);

  const { sendViewSuggestedAskAIEvent } = useGetSvvManageBpEvents();

  const wrapperRefHeight = wrapperRef.current?.getBoundingClientRect()?.height;
  const titleBoxRefHeight = titleBoxRef.current?.getBoundingClientRect()?.height;

  useEffect(function handleComponentMount() {
    sendViewSuggestedAskAIEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showTitle = useBreakpointValue({
    base: Boolean(
      wrapperRefHeight && titleBoxRefHeight && wrapperRefHeight - titleBoxRefHeight > 100,
    ),
  });

  return (
    <Flex
      h="100%"
      flexDirection="column"
      flex="1 1 auto"
      gap="8px"
      ref={wrapperRef}
      p="16px"
      me="auto"
      data-testid="viewer-qna-questions"
    >
      <Flex
        ref={titleBoxRef}
        alignItems="center"
        justifyContent="center"
        height="100%"
        flexDirection="column"
      >
        {showTitle && (
          <>
            <AiSparkles h="36px" w="36px" color={'text-secondary'} />
            <Box mt={rem(10)} textAlign={'center'} color={'text-secondary'} fontSize={'text-sm'}>
              {finalCopy.chooseAQuestion}
            </Box>
          </>
        )}
      </Flex>
      <MultilingualSelector
        languages={uniqueLanguages}
        selectedLanguage={selectedLanguage}
        onSelectLanguage={onSelectLanguage}
        isEmbeded={isEmbeded}
      />
      {questions?.map((questionItem) => (
        <Choice
          key={questionItem.question}
          icon="empty"
          shouldWrap={true}
          onClick={() => onAskPredefinedQuestion(questionItem)}
        >
          {questionItem.question}
        </Choice>
      ))}
    </Flex>
  );
};
